var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header d-flex align-items-center pl-2"},[_c('span',{staticClass:"text-uppercase text-light font-weight-bold",attrs:{"id":"title"}},[_vm._t("title",[_vm._v("Passport")])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }